module.exports = __webpack_public_path__ + "fonts/vector_4.svg";